
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import Button from "../../../common/button/Button";
import FieldText from "./FieldText";


export default function Form({ discussion, onSuccess }) {
	const [text, setText] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTextChange = (e) => {
		setText(e.target.value);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.answerAdd({
			token: LoginHelper.getToken(),
			discussion_id: discussion.id,
			text: text,
		}).then((res) => {
			setIsLoading(false);
			setText("");
			onSuccess();
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<div className="flex flex-col gap-4 bg-white rounded-[10px] p-4">
			<div className="spacer p-[1px]"></div>
			<FieldText
				text={text}
				onChange={handleTextChange}
			/>
			<div className="spacer p-[1px]"></div>
			<div className="flex flex-row justify-end">
				<div className="min-w-[100px] min-h-[40px]">
					<Button
						onClick={() => { handleSubmit() }}
						label={"پاسخ"}
						isLoading={isLoading}
					/>
				</div>
			</div>
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
